import {Json} from '../../../components/JsonObjectCard';
import {RequestExample} from '../../../components/RequestExampleCard';
import {RequestDefinitionData} from "../../../components/RequestDefinition";

const deletePurchaseOrderRequest: RequestExample = {
    title: {
        verb: 'DELETE',
        endpointUrl: '/api/purchase-orders/:id',
    },
    curl:
        `curl --location \\
--request DELETE '<YOUR SERVER>/api/purchase-orders/:id' \\
--header 'Authorization: Bearer <TOKEN>'
`,
};

const deletePurchaseOrdersResponse: Json = {
    title: 'RESPONSE',
    json: {},
};

const data: RequestDefinitionData = {
    id: 'delete-purchase-order',
    title: 'Delete a purchase order',
    description: 'Deletes the purchase order with the specified ID.',
    endpoint: {
        verb: 'DELETE',
        path: '/purchase-orders/:id',
        tooltip: 'Delete a purchase order',
    },
    attributes: [],
    requestObject: deletePurchaseOrderRequest,
    responseObject: deletePurchaseOrdersResponse,
};

export default data;
